module.exports = __webpack_public_path__ + "img/growthAbility6.4dc9adbb.png";